import BaseService from "../baseService";
class ContatoEmail extends BaseService {
    constructor(id) {
        const resource = "contato-email";
        let relationship = {};
        super(id, relationship, resource);
    }
}

export default (id) => new ContatoEmail(id);
